/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Scrollbars } from 'react-custom-scrollbars';
import { connect } from 'react-redux';

// actions
import { updateAppComponentHeight } from '../../reducers/App/actions';

// constants
import {
  RESOURCE_BASE_URL,
  TSLA_HEADER_MAIN,
  VEHICLE_SELECTOR,
} from '../../lib/Constants';

// components
import Btn from '../Btn';

// helpers
import { getNodeHeight, getComponentHeight } from '../../lib/Utils';

// assets
import models from '../../images/trip-ms.png';
import modelx from '../../images/trip-mx.png';
import model3 from '../../images/trip-m3.png';
import modely from '../../images/trip-my.png';
import bfr from '../../images/trip-bfr.png';
import models2x from '../../images/trip-ms@2x.png';
import modelx2x from '../../images/trip-mx@2x.png';
import model32x from '../../images/trip-m3@2x.png';
import modely2x from '../../images/trip-my@2x.png';
import bfr2x from '../../images/trip-bfr@2x.png';

const images = {
  MS: models,
  MX: modelx,
  M3: model3,
  MY: modely,
  BFR: bfr,
};

const retinaImages = {
  MS: models2x,
  MX: modelx2x,
  M3: model32x,
  MY: modely2x,
  BFR: bfr2x,
};

const DropdownProps = {
  toggle: PropTypes.bool.isRequired, // State (open/closed) of the component drop-down
  children: PropTypes.node, // Can be plain text or additional markup for styling button
  isMobile: PropTypes.bool.isRequired, // For mobile functionality and style manipulation
  editing: PropTypes.bool.isRequired, // If the user is editing their trip
  windowHeight: PropTypes.number.isRequired, // Current height of the browser window
  isLoading: PropTypes.bool.isRequired, // Is the application loading
  componentHeights: PropTypes.arrayOf(PropTypes.object).isRequired, // height of component containers
};

const DropdownDefaultProps = {
  children: null,
};

const Dropdown = props => {
  const {
    toggle,
    isMobile,
    editing,
    children,
    windowHeight,
    isLoading,
    componentHeights,
  } = props;

  if (isLoading) return <div className="section-loader" />;

  return (
    <ul
      className={classNames('vehicle-drop-down', {
        'vehicle-drop-down--collapsed':
          (!toggle && !isMobile) || (!toggle && !editing),
        'vehicle-drop-down--mobile': isMobile && editing,
      })}
    >
      <Scrollbars
        style={{
          height:
            windowHeight -
            (getComponentHeight({
              components: componentHeights,
              component: VEHICLE_SELECTOR,
            }) +
              getNodeHeight(TSLA_HEADER_MAIN)),
        }}
      >
        {children}
      </Scrollbars>
    </ul>
  );
};

Dropdown.propTypes = DropdownProps;

Dropdown.defaultProps = DropdownDefaultProps;

const CollapsedSelectorComponentPropTypes = {
  handleClick: PropTypes.func.isRequired, // Method to invoke when the component is clicked
  toggle: PropTypes.bool.isRequired, // State (open/closed) of the component drop-down
  name: PropTypes.string.isRequired, // Vehicle name
  isMobile: PropTypes.bool.isRequired, // For mobile functionality and style manipulation
  modelCode: PropTypes.string.isRequired, // Model code for routing service
  styles: PropTypes.shape({}), // CSS properties for keeping track of animation state
  dispatchComponentHeight: PropTypes.func.isRequired,
};

const CollapsedSelectorComponentDefaultProps = {
  styles: {},
  name: '',
};

class CollapsedSelectorComponent extends Component {
  componentDidMount() {
    const { dispatchComponentHeight } = this.props;
    dispatchComponentHeight(VEHICLE_SELECTOR, this.component.offsetHeight);
  }

  render() {
    const {
      handleClick,
      toggle,
      name,
      isMobile,
      modelCode,
      styles,
    } = this.props;
    const vehicleSelectorRef = el => {
      this.component = el;
    };

    return (
      <div
        style={styles}
        className={classNames('vehicle-selector', {
          hidden: toggle && !isMobile,
        })}
        onClick={e => handleClick(e)}
        role="menu"
        tabIndex="0"
        ref={vehicleSelectorRef}
        aria-label="vehicle selector"
      >
        <div className="vehicle-selector__img" role="menuitem">
          <img
            src={images[modelCode]}
            srcSet={`${images[modelCode]} 1x,${RESOURCE_BASE_URL}${
              retinaImages[modelCode]
            } 2x`}
            alt={name}
          />
        </div>
        <div className="vehicle-selector__details">
          <span className="vehicle-selector__details-name">{name}</span>
        </div>
        <div className="vehicle-selector__icon">
          <i
            className={classNames({
              'tsla-icon-angle_down': !toggle,
              'tsla-icon-angle_up': toggle,
            })}
          />
        </div>
      </div>
    );
  }
}

CollapsedSelectorComponent.propTypes = CollapsedSelectorComponentPropTypes;

CollapsedSelectorComponent.defaultProps = CollapsedSelectorComponentDefaultProps;

const mapCollapsedSelectorDispatchToProps = dispatch => ({
  dispatchComponentHeight: (component, height) => {
    dispatch(updateAppComponentHeight(component, height));
  },
});

const CollapsedSelector = connect(
  null,
  mapCollapsedSelectorDispatchToProps,
)(CollapsedSelectorComponent);

const SelectorPropTypes = {
  toggle: PropTypes.bool.isRequired, // State (open/closed) of the component drop-down
  handleBtnClick: PropTypes.func.isRequired, // Callback for vehicle selector CTA
  btnLabel: PropTypes.string.isRequired, // Label for vehicle selector CTA
  children: PropTypes.node, // Child components and elements passed to Selector
  editing: PropTypes.bool.isRequired, // If the route is being edited
  componentHeights: PropTypes.arrayOf(PropTypes.object).isRequired, // Height of component containers
};

const SelectorDefaultProps = {
  children: null,
};

const Selector = props => {
  const { toggle, handleBtnClick, btnLabel, children } = props;

  return (
    <div>
      <CollapsedSelector {...props} />
      <Dropdown {...props}>{children}</Dropdown>
      <div
        className={classNames('vehicle-selector__disclaimer', {
          hidden: !toggle,
        })}
      >
        <Btn
          styles={classNames(`btn-secondary vehicle-selector__disclaimer-btn`)}
          handleClick={handleBtnClick}
        >
          {btnLabel}
        </Btn>
      </div>
    </div>
  );
};

Selector.propTypes = SelectorPropTypes;

Selector.defaultProps = SelectorDefaultProps;

const SelectorItemPropTypes = {
  longName: PropTypes.string.isRequired, // Vehicle label
  modelCode: PropTypes.string.isRequired, // Short model code [MS, MX, M3] etc...
  model: PropTypes.string.isRequired, // Vehicle model
  isMobile: PropTypes.bool.isRequired, // For mobile functionality and style manipulation
  shortName: PropTypes.string.isRequired, // Short name for vehicle
  children: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.object),
  ]).isRequired, // Child components and elements passed to Selector
  handleClick: PropTypes.func, // Method to invoke when the component is clicked
  driveTrain: PropTypes.string.isRequired, // Vehicle drive train (2WD/4WD)
};

const SelectorItemDefaultProps = {
  longName: 'Model S Sedan',
  model: 'MS_2017_100D',
  handleClick: null,
  isMobile: false,
  modelCode: 'MS',
  shortName: 'Model S',
  children: [],
  driveTrain: 'All-Wheel Drive',
};

const SelectorItem = props => {
  const {
    handleClick,
    longName,
    model,
    isMobile,
    modelCode,
    shortName,
    children,
    driveTrain,
  } = props;

  if (isMobile) {
    return (
      <li
        className="vehicle-drop-down__heading"
        onClick={e => handleClick(e)}
        role="menuitem"
      >
        <i className="tsla-icon-angle_up" />
        <span className="vehicle-drop-down--vehicle-name">{longName}</span>
      </li>
    );
  }

  return (
    <li
      className="vehicle"
      data-model={model}
      data-model-code={modelCode}
      data-short-name={shortName}
    >
      <div className="vehicle__img">
        <img
          src={images[modelCode]}
          srcSet={`${images[modelCode]} 1x, ${RESOURCE_BASE_URL}${
            retinaImages[modelCode]
          } 2x`}
          alt={longName}
          data-image={images[modelCode]}
        />
      </div>
      <div className="vehicle__details">
        <span className="vehicle__details-name">{longName}</span>
        <span>{driveTrain}</span>
      </div>
      <SelectorList>{children}</SelectorList>
    </li>
  );
};

SelectorItem.propTypes = SelectorItemPropTypes;

SelectorItem.defaultProps = SelectorItemDefaultProps;

const SelectorListPropTypes = {
  children: PropTypes.node.isRequired, // Child components and elements passed to component
};

const SelectorListDefaultProps = {
  children: {},
};

const SelectorList = props => (
  <ul className="vehicle-variants">{props.children}</ul>
);

SelectorList.propTypes = SelectorListPropTypes;

SelectorList.defaultProps = SelectorListDefaultProps;

const SelectorVariantPropTypes = {
  description: PropTypes.string.isRequired, // Description of vehicle
  selected: PropTypes.bool.isRequired, // The selected vehicle
  handleClick: PropTypes.func.isRequired, // Method to invoke when the component is clicked
  model: PropTypes.string.isRequired, // Vehicle model
  modelCode: PropTypes.string.isRequired, // Short model code [MS, MX, M3] etc...
  shortName: PropTypes.string.isRequired, // Short name for vehicle
  name: PropTypes.string.isRequired, // Vehicle name
  rangeValue: PropTypes.string.isRequired, // Formatted vehicle range
  longName: PropTypes.string.isRequired, // Vehicle label
  driveTrain: PropTypes.string.isRequired, // Vehicle drive train (RWD/AWD)
  last: PropTypes.bool.isRequired, // True if the component is the last component in an array
  disclaimer: PropTypes.string.isRequired, // Vehicle range disclaimer
};

const SelectorVariant = props => {
  const {
    handleClick,
    selected,
    description,
    model,
    modelCode,
    shortName,
    name,
    rangeValue,
    longName,
    driveTrain,
    last,
    disclaimer,
    unit,
  } = props;

  return (
    <li
      onClick={e => handleClick(e)}
      role="menuitem"
      data-name={name}
      data-long-name={longName}
      data-short-name={shortName}
      data-description={description}
      data-range-value={rangeValue}
      data-model={model}
      data-model-code={modelCode}
      data-drive-train={driveTrain}
    >
      <span
        className={classNames('vehicle-variants__radio', {
          'vehicle-variants__radio--selected': selected,
        })}
      />
      <b className="vehicle-variants__description">{description}</b>
      <span className="vehicle-variants__range">{rangeValue}</span>
      {last && <p className="vehicle-variants__disclaimer">{disclaimer}</p>}
    </li>
  );
};

SelectorVariant.propTypes = SelectorVariantPropTypes;

export {
  Selector,
  SelectorItem,
  SelectorVariant,
  Dropdown,
  CollapsedSelectorComponent,
  SelectorList,
};
